export const copyToClipboard = (data: string): Promise<void> => {
  return navigator.clipboard.writeText(data);
};
